/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Media Blog API
 * API сервиса статей (MVP).
 * OpenAPI spec version: 1.12.0
 */
import { fetcher } from '../../../utils/fetcher';
import type {
  EntityCreateTagReq,
  EntityTag,
  EntityUpdateTagReq,
  ErrorhandlerErrorResponse,
  PostAdminV1Tags200,
  PutAdminV1TagsId200,
} from '../../models';

/**
 * Create a new tag with name
 * @summary Create a new tag
 */
export type postAdminV1TagsResponse200 = {
  data: PostAdminV1Tags200;
  status: 200;
};

export type postAdminV1TagsResponse400 = {
  data: ErrorhandlerErrorResponse;
  status: 400;
};

export type postAdminV1TagsResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type postAdminV1TagsResponseComposite =
  | postAdminV1TagsResponse200
  | postAdminV1TagsResponse400
  | postAdminV1TagsResponse500;

export type postAdminV1TagsResponse = postAdminV1TagsResponseComposite & {
  headers: Headers;
};

export const getPostAdminV1TagsUrl = () => {
  return `/admin/v1/tags`;
};

export const postAdminV1Tags = async (
  entityCreateTagReq: EntityCreateTagReq,
  options?: RequestInit
): Promise<postAdminV1TagsResponse> => {
  return fetcher<postAdminV1TagsResponse>(getPostAdminV1TagsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(entityCreateTagReq),
  });
};

/**
 * Update the name of a tag by ID
 * @summary Update tag by ID
 */
export type putAdminV1TagsIdResponse200 = {
  data: PutAdminV1TagsId200;
  status: 200;
};

export type putAdminV1TagsIdResponse400 = {
  data: ErrorhandlerErrorResponse;
  status: 400;
};

export type putAdminV1TagsIdResponse404 = {
  data: ErrorhandlerErrorResponse;
  status: 404;
};

export type putAdminV1TagsIdResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type putAdminV1TagsIdResponseComposite =
  | putAdminV1TagsIdResponse200
  | putAdminV1TagsIdResponse400
  | putAdminV1TagsIdResponse404
  | putAdminV1TagsIdResponse500;

export type putAdminV1TagsIdResponse = putAdminV1TagsIdResponseComposite & {
  headers: Headers;
};

export const getPutAdminV1TagsIdUrl = (id: string) => {
  return `/admin/v1/tags/${id}`;
};

export const putAdminV1TagsId = async (
  id: string,
  entityUpdateTagReq: EntityUpdateTagReq,
  options?: RequestInit
): Promise<putAdminV1TagsIdResponse> => {
  return fetcher<putAdminV1TagsIdResponse>(getPutAdminV1TagsIdUrl(id), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(entityUpdateTagReq),
  });
};

/**
 * Delete a tag by its ID
 * @summary Delete tag by ID
 */
export type deleteAdminV1TagsIdResponse204 = {
  data: null;
  status: 204;
};

export type deleteAdminV1TagsIdResponse404 = {
  data: ErrorhandlerErrorResponse;
  status: 404;
};

export type deleteAdminV1TagsIdResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type deleteAdminV1TagsIdResponseComposite =
  | deleteAdminV1TagsIdResponse204
  | deleteAdminV1TagsIdResponse404
  | deleteAdminV1TagsIdResponse500;

export type deleteAdminV1TagsIdResponse =
  deleteAdminV1TagsIdResponseComposite & {
    headers: Headers;
  };

export const getDeleteAdminV1TagsIdUrl = (id: string) => {
  return `/admin/v1/tags/${id}`;
};

export const deleteAdminV1TagsId = async (
  id: string,
  options?: RequestInit
): Promise<deleteAdminV1TagsIdResponse> => {
  return fetcher<deleteAdminV1TagsIdResponse>(getDeleteAdminV1TagsIdUrl(id), {
    ...options,
    method: 'DELETE',
  });
};

/**
 * Retrieve the list of all tags
 * @summary Get all tags
 */
export type getV1TagsResponse200 = {
  data: EntityTag[];
  status: 200;
};

export type getV1TagsResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type getV1TagsResponseComposite =
  | getV1TagsResponse200
  | getV1TagsResponse500;

export type getV1TagsResponse = getV1TagsResponseComposite & {
  headers: Headers;
};

export const getGetV1TagsUrl = () => {
  return `/v1/tags`;
};

export const getV1Tags = async (
  options?: RequestInit
): Promise<getV1TagsResponse> => {
  return fetcher<getV1TagsResponse>(getGetV1TagsUrl(), {
    ...options,
    method: 'GET',
  });
};

/**
 * Tag info
 * @summary Get tag by id
 */
export type getV1TagsIdResponse200 = {
  data: EntityTag;
  status: 200;
};

export type getV1TagsIdResponse500 = {
  data: ErrorhandlerErrorResponse;
  status: 500;
};

export type getV1TagsIdResponseComposite =
  | getV1TagsIdResponse200
  | getV1TagsIdResponse500;

export type getV1TagsIdResponse = getV1TagsIdResponseComposite & {
  headers: Headers;
};

export const getGetV1TagsIdUrl = (id: string) => {
  return `/v1/tags/${id}`;
};

export const getV1TagsId = async (
  id: string,
  options?: RequestInit
): Promise<getV1TagsIdResponse> => {
  return fetcher<getV1TagsIdResponse>(getGetV1TagsIdUrl(id), {
    ...options,
    method: 'GET',
  });
};
